import { ValuationSource } from '@popety-io/types'

// Official brand colors for AVM providers - Single source of truth
export const VALUATION_PROVIDER_COLORS: Record<string, string> = {
  [ValuationSource.POPETY_IO]: '#0294df', // Popety.io cyan
  [ValuationSource.PRICE_HUBBLE]: '#014EFB', // PriceHubble blue
  [ValuationSource.WUEST_PARTNER]: '#332F62', // Wüest Partner purple
  [ValuationSource.MANUAL]: '#F38181', // Manual valuations coral
  [ValuationSource.LISTINGS_COMPARABLES]: '#10B981', // Listings comparables green
  [ValuationSource.TRANSACTIONS_COMPARABLES]: '#F59E0B', // Transactions comparables amber
}

export const getProviderColor = (source: ValuationSource | string): string => {
  return VALUATION_PROVIDER_COLORS[source] || '#666666'
}

export const getProviderInfo = (
  source: ValuationSource | string
): { name: string; color: string } => {
  switch (source) {
    case ValuationSource.POPETY_IO:
      return { name: 'Popety.io', color: '#0294df' }
    case ValuationSource.PRICE_HUBBLE:
      return { name: 'PriceHubble', color: '#014EFB' }
    case ValuationSource.WUEST_PARTNER:
      return { name: 'Wüest Partner', color: '#332F62' }
    case ValuationSource.MANUAL:
      return { name: 'Manual', color: '#F38181' }
    case ValuationSource.LISTINGS_COMPARABLES:
      return { name: 'Listings Comparables', color: '#10B981' }
    case ValuationSource.TRANSACTIONS_COMPARABLES:
      return { name: 'Transactions Comparables', color: '#F59E0B' }
    default:
      return { name: 'Unknown', color: '#666666' }
  }
}
